<template>
    <div class="invitation">
        <div class="invitation-bg" @scroll="scroll">
            <div class="invitation-wrap">
                <a v-if="data.secretary_tel" :href="'tel:'+data.secretary_tel" class="invitation-customer">
                    <img src="@/assets/images/invitation/invitation_customer.png" alt="">
                    <span>客服</span>
                </a>
                <img class="invitation-header" :src="data.top_cover" alt="">
                <div class="invitation-content" :style="{background:'url('+data.bottom_cover+') no-repeat left top'}">
                    <div class="invitation-text">
                        尊敬的【{{data.expert_name}}】教授：
                        <br>
                        {{data.remark}}
                    </div>
                    <div style="display:flex; flex-direction: column; align-items: center; width:100%;">
                        <div class="invitation-mode">
                            <img class="invitation-mode-img" src="@/assets/images/invitation/invitation_mode_1.png"
                                alt="">
                            <p class="invitation-mode-text"> 您可以凭此邀约码在<img class="invitation-pc-logo"
                                    src="@/assets/images/invitation/invitation_pc_logo.png" alt="">医谱客户端上通过
                                <a class="invitation-mode-phone">{{data.tel}}</a>
                                账号登录后进行录制内容上传操作！</p>
                            <div class="invitation-code">
                                <div class="invitation-code-wrap"> <span class="invitation-code-tips">您的邀请码：</span>
                                    <span class="invitation-code-code">{{data.code}}</span></div>
                                <div style="flex:1;"></div>
                                <div @click="copy(data.code,'.invitation-copy')" class="invitation-copy">复制</div>
                            </div>
                        </div>
                        <div class="invitation-mode mode-node2">
                            <img class="invitation-mode-img" src="@/assets/images/invitation/invitation_mode_2.png"
                                alt="">
                            <p class="invitation-mode-text">
                                您可以复制此链接在电脑端浏览器中打开，即可录制课件内容，若您已在电脑端打开此邀约页面，可以直接点击下方【立即开启录制】按钮，进行录制操作！
                            </p>
                            <div @click="copy(url,'.invitation-copy-link')" class="invitation-copy-link">复制链接</div>
                        </div>
                    </div>
                    <img class="invitation-platform" src="@/assets/images/invitation/invitation_platform.png" alt="">
                    <img class="invitation-platform-logo" src="@/assets/images/invitation/invitation_logo.png" alt="">
                </div>
            </div>

        </div>
        <div class="invitation-start">
            <img @click="startRecording" class="invitation-start-img"
                src="@/assets/images/invitation/invitation_start.png" alt="">
        </div>
        <div class="invitation-buttons">
            <template v-for="(button, index) in data.button">
                <img @click="toArticle(button)" :key="index" class="invitation-button" :src="button.logo" alt="">
            </template>
        </div>
    </div>
</template>

<script>
    import {
        Toast
    } from 'vant'
    import Request from '@request'
    import api from '@api'
    import host from '@host'
    import ClipboardJS from '@/js/clipboard.min.js'

    export default {
        components: {},
        props: {},
        data() {
            return {
                data: {},
                url: host.weakup_host + '/weakup/weakup.html',
                mode_node2: null,
                bg: null,
                is_changed: false
            }
        },
        computed: {

        },
        created() {
            this.getData()
        },
        mounted() {

            this.mode_node2 = document.querySelector('.mode-node2')
            this.bg = document.querySelector('.invitation-bg')
        },
        methods: {
            scroll(e) {
                if ((e.target.scrollTop + this.bg.getBoundingClientRect().height) > this.mode_node2.offsetTop) {
                    if (!this.is_changed) {
                        this.mode_node2.style.visibility = 'hidden'
                        setTimeout(() => {
                            this.mode_node2.style.visibility = 'visible'
                        }, 0)
                        this.is_changed = true
                    }
                } else {
                    this.is_changed = false
                }
            },
            getData() {
                Request.get(api.invitation.inviteIndex, {
                    id: this.$route.query.id,
                }).then(res => {
                    const {
                        data
                    } = res
                    this.data = data
                    document.title = data.theme
                    this.url += ('?code=' + data.code)
                })
            },
            toArticle(info) {
                this.$router.push({
                    name: 'InvitationArticle',
                    query: {
                        id: info.id
                    }
                })
            },
            copy(text, cls) {
                const clipboard = new ClipboardJS(cls, {
                    text: function (trigger) {
                        return text
                    }
                })
                clipboard.on('success', (e) => {
                    Toast('复制成功')
                    e.clearSelection()
                })
            },
            startRecording() {
                location.href = this.url
            },

        },
    }
</script>
<style>

</style>
<style scoped>
    .invitation {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .invitation-bg {
        flex: 1;
        width: 100%;
        /* height: 100%; */
        /* background: url(../../assets/images/invitation/invitation_bg.png) no-repeat left top; */
        background-size: 100% 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .invitation-wrap {
        width: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .invitation-header {
        width: 100%;
    }

    .invitation-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .invitation-text {
        width: 85%;
        margin: 0.6rem 0;
        font-size: 0.6rem;
        color: #444444;
        padding: 0.66rem;
        border-radius: 10px;
        border: solid 4px #ffba83;
        background: white;
    }

    .invitation-mode {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 85%;
        margin: 0.6rem 0;
        font-size: 0.6rem;
        color: #444444;
        padding: 0.66rem;
        border-radius: 10px;
        border: solid 4px #ffba83;
        background: white;
        position: relative;
    }

    .invitation-mode-img {
        width: 6.4rem;
        position: relative;
        top: -1.4rem;
    }

    .invitation-mode-text {
        margin-top: -1rem;
        width: 100%;
    }

    .invitation-pc-logo {
        width: 0.7rem;
        margin-left: 0.1rem;
        margin-right: 0.1rem;
    }

    .invitation-mode-phone {
        color: #2d347b;
    }

    .invitation-code {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
    }

    .invitation-code-wrap {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .invitation-code-tips {
        font-size: 0.6rem;
        color: #444444;
    }

    .invitation-code-code {
        font-size: 0.85rem;
        font-weight: bold;
        letter-spacing: 0.3rem;
        color: #444444;
    }

    .invitation-copy {
        width: 2.56rem;
        height: 1.28rem;
        background-color: #ffba82;
        border-radius: 0.64rem;
        font-size: 0.6rem;
        color: #e05315;
        text-align: center;
        line-height: 1.28rem;
        cursor: pointer;
    }

    .invitation-copy-link {
        margin-top: 0.5rem;
        width: 3.84rem;
        height: 1.28rem;
        background-color: #ffba82;
        color: #e05315;
        border-radius: 0.64rem;
        text-align: center;
        line-height: 1.28rem;
        cursor: pointer;
    }

    .invitation-platform {
        margin-top: 1.3rem;
        width: 70%;
    }

    .invitation-platform-logo {
        margin-top: 1rem;
        margin-bottom: 1.6rem;
        width: 70%;
    }

    .invitation-start {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        background-color: #ffffff;
        border-radius: 0.43rem 0.43rem 0rem 0rem;
    }

    .invitation-start-img {
        width: 14.29rem;
        cursor: pointer;
    }

    .invitation-buttons {
        display: flex;
        flex-direction: column;
        position: absolute;
        right: 0.45rem;
        bottom: 5rem;
    }

    .invitation-button {
        width: 2.16rem;
        cursor: pointer;
        margin-bottom: 0.5rem;
    }

    .invitation-customer {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 2.56rem;
        height: 1.07rem;
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 0.53rem 0rem 0rem 0.53rem;
        position: absolute;
        top: 0.64rem;
        right: 0;
        cursor: pointer;
    }

    .invitation-customer img {
        margin-left: 0.4rem;
        width: 0.51rem;
    }

    .invitation-customer span {
        margin-left: 0.2rem;
        font-size: 0.51rem;
        color: #ffffff;
    }
</style>